import { useEffect, useState, useCallback } from "react";
import { Navigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import AdminUpload from "../components/dashboard/AdminUpload";
import Header from "../components/dashboard/Header";

function fmtDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
}

export default function Manage() {
  const { user } = useAuth();
  const [uploads, setUploads] = useState([]);

  const loadUploads = useCallback(async () => {
    const u = await api.get("/admin/uploads");
    setUploads(u.data.uploads);
  }, []);
  useEffect(() => { if (user?.role === "admin") loadUploads(); }, [user, loadUploads]);

  if (user && user.role !== "admin") return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-brand-page relative z-10">
      <Header />

      <main className="max-w-5xl mx-auto px-6 lg:px-12 py-10 space-y-6">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-brand-tertiary">Administration</p>
          <h1 className="font-serif text-4xl lg:text-5xl font-light tracking-tight text-brand-ink mt-2">Monthly Data</h1>
          <p className="text-sm text-brand-muted mt-1">At the start of each month, upload the prior month's workbook. New months are added to the data; existing months are refreshed.</p>
        </div>

        <AdminUpload onUploaded={loadUploads} />

        <div className="bg-brand-surface border border-brand-border" data-testid="upload-history">
          <div className="px-6 py-4 border-b border-brand-border">
            <p className="text-xs uppercase tracking-[0.15em] text-brand-tertiary">Upload History</p>
          </div>
          {uploads.length === 0 ? (
            <p className="px-6 py-4 text-sm text-brand-tertiary">No uploads yet.</p>
          ) : (
            <table className="w-full text-sm">
              <tbody>
                {uploads.map((u) => (
                  <tr key={`${u.filename}-${u.uploaded_at}`} className="border-b border-brand-border last:border-0">
                    <td className="px-6 py-3 text-brand-ink">{u.filename}</td>
                    <td className="px-4 py-3 text-brand-muted hidden sm:table-cell">{u.records} rows · {u.months ? u.months.length : "\u2014"} months</td>
                    <td className="px-6 py-3 text-right text-brand-tertiary text-xs">{fmtDate(u.uploaded_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </main>
    </div>
  );
}
